export default __webpack_public_path__ + "static/media/change-field-dark.e7e5a3f9.svg";